import { render } from "./dataTableMpReports.vue?vue&type=template&id=515c44a6"
import script from "./dataTableMpReports.vue?vue&type=script&lang=js"
export * from "./dataTableMpReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__